
import React from 'react';
import './Header.css';

function Header() {
  return (
    <header className="app-header">
      <h1>ThrillArts</h1>
    </header>
  );
}

export default Header;
